import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Person from "@/shared/model/person";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import PersonAddressComponent from "@/modules/OrganisationStructure/components/PersonAddressComponent.vue";
import Address from "@/shared/model/Address";
import {computed} from "vue";


interface Props {
  person?: Person
  address?: Address
  allowSelect?: boolean
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'PersonAddressCardComponent',
  props: {
    person: { default: undefined },
    address: { default: undefined },
    allowSelect: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props
const _classCard = computed(() => {
  let res = "sog-card"
  /*
    if(props.isSelected){
      res += " selected"
    }
  */
  if (props.allowSelect) {
    res += " allow-select"
  }
  return res

})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, {
    class: _normalizeClass(_classCard.value)
  }, {
    default: _withCtx(() => [
      _createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createVNode(PersonAddressComponent, {
            person: __props.person,
            address: __props.address
          }, null, 8, ["person", "address"])
        ]),
        _: 1
      }),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})